import { render, staticRenderFns } from "./BtIdResolutionDefiner.vue?vue&type=template&id=393d82b3&"
import script from "./BtIdResolutionDefiner.vue?vue&type=script&lang=js&"
export * from "./BtIdResolutionDefiner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports